var OptInStrings = {
    pageTitle: function () {
        return 'Enroll to activate your DoorDash for Business meal benefits';
    },
    pageSubtitle: function () {
        return "Delicious meals are waiting. Enter your work email address to activate your company's meal benefits.";
    },
    enterWorkEmailAddress: function () { return 'Enter Your Work Email Address'; },
    workEmailAddressPlaceholder: function () { return 'Enter work email address'; },
    enroll: function () { return 'Enroll'; },
    enrollErrors: {
        fieldIsRequired: function () { return 'Field is required.'; },
        enterValidEmail: function () { return 'Please enter a valid email address.'; },
    },
    howToEnroll: {
        title: function () { return "Here's how to enroll"; },
        subtext: function () {
            return "Follow these steps to activate your company's meal benefits.";
        },
        step1: {
            title: function () { return 'Enter your work email address'; },
            subtext: function () {
                return 'Enter the email address that you use for work and click Enroll.';
            },
        },
        step2: {
            title: function () { return 'Activate your meal benefits'; },
            subtext: function () { return "You'll receive an email to activate your meal benefits."; },
        },
        step3: {
            title: function () { return 'Enjoy company meal benefits'; },
            subtext: function () {
                return "Start enjoying your company's meal benefits when you order on DoorDash.";
            },
        },
    },
    verifyEmailAddressModal: {
        title: function () { return 'Check Your Inbox'; },
        subtext: function () {
            return "We'll send an email if your company provides DoorDash work benefits. Once you receive the email, click on the button to continue.";
        },
        gotIt: function () { return 'Got It'; },
    },
};
export default OptInStrings;
